// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__maytra_8700f0', '__maytra_Fallback_8700f0'"},"className":"__className_8700f0"};